package one.healthium.locale

import one.healthium.Platform

class LocaleProvider(
    private val platform: Platform
) {
    private val supportedLocales = setOf("en", "de", "fr", "es")
    private val defaultLocale = "en"

    /**
     * Returns the first supported locale from the list of preferred languages
     * or fallback to "en" if none is supported
     *
     * Example: preferredLanguages = ["ru", "de", "en"] -> returns "de"
     */
    fun getLocale(): String {
        for (lang in platform.deviceInfo.preferredLanguages) {
            val normalized = lang.take(2).lowercase()
            if (normalized in supportedLocales) {
                return normalized
            }
        }
        return defaultLocale
    }
}
